// eslint-disable-next-line max-classes-per-file
export class Document {
  public isFolder: boolean;
  public name = '';
  public path = '';
}

export class RenameDocument extends Document {
  public newName = '';
}
